import SelectField from "components/controls/SelectField";
import { useTaxonomyOptions } from "hooks/useTaxonomyOptions";
import { ETaxonomy, IRowItem } from "library/types";
import { IPackageRowItem } from "../PackagesView/components/BenefitImplementationPackages/shared";

type Props = {
  item: IPackageRowItem | IRowItem;
  fieldName: string;
  readOnly?: boolean;
  taxonomyName: ETaxonomy;
};

export function SelectTaxonomyCell({
  item,
  fieldName,
  taxonomyName,
  readOnly,
}: Props) {
  const options = useTaxonomyOptions(ETaxonomy[taxonomyName]);

  const value = options.find((option) => {
    return option.value === item[fieldName];
  });

  if (readOnly) {
    return value?.text;
  }

  return (
    <SelectField
      onClick={(e) => {
        e.stopPropagation();
      }}
      showEmptyOption
      error={""}
      setFieldValue={(name, newValue) => {
        const updatedValue = newValue?.value ? newValue.value : newValue;
        const updatedItem = {
          ...item,
          [fieldName]: updatedValue,
          isEdited: true,
        };
        item.updateState(updatedItem);
      }}
      value={value as any}
      label=""
      options={options}
      name={fieldName}
      noErrorSection
      noLabel
    />
  );
}
